import "primeicons/primeicons.css"; //icons
import { Button } from "primereact/button";
import "primereact/resources/primereact.min.css"; //core css
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import { bool, func } from 'prop-types';
import React from 'react';
import { useLocation } from 'react-router';
import './Burger.css';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Burger
Description : Botón encargado de desplegar el menú lateral de la aplicación
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se implementa el botón desde cero
================================================================================ */

const Burger = ({ open, setOpen }) => {

    const location = useLocation();

    if (location.pathname.match(/Login/) || location.pathname.match(/Register/) || location.pathname.match(/CompleteRegister/) || location.pathname.match(/Logout/)) {
        return null;
    }
    if (localStorage.getItem("type") === "ADMIN" && localStorage.getItem("logo")) {
        return (
            <Button className="burgerButton" icon={open ? "pi pi-times" : "pi pi-bars"} style={{ marginTop: "10px" }} open={open} onClick={() => setOpen(!open)} />
        )
    }
    if (localStorage.getItem("type") === "CLIENT" || !(localStorage.getItem("logo"))) {
        return (
            <Button className="burgerButton" icon={open ? "pi pi-times" : "pi pi-bars"} style={{ marginTop: "5px" }} open={open} onClick={() => setOpen(!open)} />
        )
    }
    else {
        return null
    }
}
Burger.propTypes = {
    open: bool.isRequired,
    setOpen: func.isRequired,
}

export default Burger;